import { render, staticRenderFns } from "./MenuEstudiante.vue?vue&type=template&id=6c261a12&"
import script from "./MenuEstudiante.vue?vue&type=script&lang=js&"
export * from "./MenuEstudiante.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports